define('presentation/account/sidebar/presentationObjects/capturedEmailAddressPresentationObject',[], function () {
    return function () {
        var self = this;

        self.id = null;
        self.capturedEmailAddress = null;
    };
});

